
import React, { Component, useRef } from 'react'
// import './TimesheetDocList.css'
import YearList from '../../../YearList'
import dayjs from 'dayjs'
import TimesheetDocument from './TimesheetDocument'


export default class TimesheetDocList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            report: false,
            reportPodtv: false
        }
    }

    SelectStatusReport = (reportPodtv) => {
        this.setState({
            reportPodtv
        })
    }

    openReport(report, timesheet_number, id_timesheetMovement, kafedra_otdel, id_years, id_months) {
        this.setState({ report, kafedra_otdel })
        if (report) {
            this.props.postTimesheetPPS(0, 0, 0, this.props.statuss, this.props.id_AVN_User, timesheet_number)
            this.props.postViewReport(true, id_timesheetMovement, timesheet_number)
            this.props.postDimDate(id_years, id_months)
        }

    }

    render() {
        const {
            Kafedra_Otdel,
            MonthList,
            BuhDocumentList
        } = this.props
        if (this.elHeight && this.elHeight == null) return null
        console.log('BuhDocumentList', BuhDocumentList)

        return (
            <div className="TimesheetMovementList" >
                <div className='Admin_container'>
                    <div className='Admin_menu'>
                        <h3 className={this.props.statusS == 0 && 'active_left'}
                            onClick={() => this.props.SelectStatusS(0)}>Кафедры</h3>
                        <h3 className={this.props.statusS == 1 && 'active_right'}
                            onClick={() => this.props.SelectStatusS(1)}>Отделы</h3>
                    </div>
                    <div className='Admin_instruments'>
                    </div>
                </div>
                <div>
                    <div className='Search_container'>
                        <div className="selectors_container" style={{ gridTemplateColumns: '0.5fr 0.5fr 1fr' }}>
                            <div>
                                <p>Год:</p>
                                <div className="selector">
                                    <h2 className="select" onClick={() => this.props.options === 0 ? this.props.OpenSelectorOptions(1, 'years') :
                                        this.props.OpenSelectorOptions(0, null)} >
                                        {this.props.id_a_year > 0 ? this.props.year : <b>Выберите год</b>}
                                    </h2>
                                    {this.props.options === 1 && this.props.option_name == 'years' ?
                                        <span>
                                            {YearList.map(({ id, name }, offset) => {
                                                return (
                                                    <p
                                                        style={{ color: this.props.id_a_year === id && '#7F9CF5' }}
                                                        key={offset} onClick={() => this.props.ChangeYear(id, name)}>
                                                        {name}
                                                    </p>
                                                )
                                            })}
                                        </span> : null}
                                </div>
                            </div>
                            <div>
                                <p>Месяц:</p>
                                <div className="selector">
                                    <h2 className="select" onClick={() => this.props.options === 0 ? this.props.OpenSelectorOptions(1, 'month') :
                                        this.props.OpenSelectorOptions(0, null)} >
                                        {this.props.id_months > 0 ? this.props.months : <b>Выберите месяц</b>}
                                    </h2>
                                    {this.props.options === 1 && this.props.option_name === 'month' ?
                                        <span>
                                            {MonthList && MonthList.length && MonthList.map((item, index) => {
                                                return (
                                                    <p
                                                        style={{ color: this.props.id_months == item.id_months && '#7F9CF5' }}
                                                        key={'months' + index} onClick={() => this.props.ChangeMonth(item.id_months, item.months)}>
                                                        {item.months}
                                                    </p>
                                                )
                                            })}
                                        </span> : null}
                                </div>
                            </div>
                            <div>
                                <p>{this.props.statusS == 0 ? 'Кафедра:' : 'Отдел:'}</p>
                                <div className="selector">
                                    <h2 className="select" onClick={() => this.props.options === 0 ? this.props.OpenSelectorOptions(1, 'kafedra') :
                                        this.props.OpenSelectorOptions(0, null)} >
                                        {this.props.id_kafedra_otdel > 0 ? this.props.kafedra_otdel : <b>Выберите {this.props.statusS == 0 ? 'кафедру' : 'отдел'}</b>}
                                    </h2>
                                    {this.props.options === 1 && this.props.option_name === 'kafedra' ?
                                        <span>
                                            {Kafedra_Otdel.map((item, index) => {
                                                return (
                                                    <p
                                                        style={{ color: this.props.id_kafedra_otdel === item.id_kafedra_otdel && '#7F9CF5' }}
                                                        key={index} onClick={() => this.props.ChangeKaf_Otdel(item.id_kafedra_otdel, item.kafedra_otdel)}>
                                                        {item.kafedra_otdel}
                                                    </p>
                                                )
                                            })}
                                        </span> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th style={{ width: '60px' }}>№</th>
                                <th style={{ width: '40%', textAlign: 'left' }}>Название {this.props.statusS == 0 ? 'кафедры' : 'отдела'}</th>
                                <th style={{ width: '40%', textAlign: 'left' }}>Составитель</th>
                                <th style={{ width: '8%' }}>Дата</th>
                            </tr>
                        </thead>
                        <tbody>
                            {BuhDocumentList && BuhDocumentList.length ? BuhDocumentList.map((item, index) => (
                                <tr key={'SpecialList' + index} onClick={() => this.openReport(true, item.timesheet_number, item.id_timesheetMovement, item.kafedra_otdel, item.id_a_year, item.id_months)}>
                                    <td>{index + 1}</td>
                                    <td style={{ textAlign: 'left', padding: '0 10px' }}>{item.kafedra_otdel}</td>
                                    <td style={{ textAlign: 'left', padding: '0 10px' }}>{item.s_t_fio}</td>
                                    <td>{item.dates} </td>
                                </tr>)) : <tr className='EmptyRow'><td colSpan='1000'>Список пока пуст</td></tr>}
                        </tbody>
                    </table>
                </div>
                {
                    this.state.report ? <div className='TimesheetPodpisAbsalut'>
                        <i className="fas fa-times" onClick={() => this.openReport(false, null, null, null)}></i>
                        <div>
                            <TimesheetDocument {...this.props} {...this.state} />
                        </div>
                    </div> : null
                }
            </div>
        )
    }
}


